// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon--dzSlu {\n  min-width: 2em;\n  max-width: 2em;\n}", "",{"version":3,"sources":["webpack://./src/gui/Apps/Broker/Nav/index.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,cAAc;AAChB","sourcesContent":[".icon {\n  min-width: 2em;\n  max-width: 2em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": "icon--dzSlu"
};
export default ___CSS_LOADER_EXPORT___;
